import axios from './index';

export const getDevices = async (filters) => {
  const queryString = getQueryString(filters, window.location.search);
  
  return axios.get(queryString ? `api/v1/devices/?${queryString}` : `api/v1/devices`);
};

export const getDevice = async (deviceId) => {
  return axios.get(`api/v1/devices/${deviceId}`);
};

export const createDevice = async (device) => {
  return axios.post(`api/v1/devices`, device);
};

export const editDevice = async (deviceId, device) => {
  return axios.put(`api/v1/devices/${deviceId}`, device);
};

export const removeDevice = async (deviceId) => {
    return axios.delete(`api/v1/devices/${deviceId}`);
};

const getQueryString = (query, search) => {

    let searchParams = new URLSearchParams(search || '');

    if (!query)
        return searchParams.toString();

    searchParams = getPagingAndOrderParams(query, searchParams);

    if (query.filters) {
        for (const property in query.filters) {

            searchParams.delete(property);
            if (query.filters[property] !== null && query.filters[property] !== undefined) {
                searchParams.append(property, query.filters[property]);
            }
        }
    }

    searchParams.delete('q');
    if (query.query) {
        searchParams.append('q', query.query);
    }

    return searchParams.toString();
}

const getPagingAndOrderParams = (newActiveFilters, searchParams) => {

  if (!newActiveFilters)
      return;

  searchParams.delete('pageIndex');
  if (newActiveFilters.pagination?.page) {
      searchParams.append('pageIndex', newActiveFilters.pagination.page);
  }
  searchParams.delete('pageSize');
  if (newActiveFilters.pagination?.sizePerPage) {
      searchParams.append('pageSize', newActiveFilters.pagination.sizePerPage);
  }
  searchParams.delete('sortField');
  if (newActiveFilters.sort?.sortField) {
      searchParams.append('sortField', newActiveFilters.sort.sortField);
  }
  searchParams.delete('sortOrder');
  if (newActiveFilters.sort?.sortOrder) {
      searchParams.append('sortOrder', newActiveFilters.sort.sortOrder);
  }

  return searchParams;
}